import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

import './error-panel.css';

const ERROR_PANEL_CLASS = 'error-panel';
const ERROR_MESSAGE_CLASS = 'error-message';

export default class ErrorPanel extends PureComponent {

  static propTypes = {
    message: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { message, className } = this.props;
    const { width, height } = this.props;

    const style = (width !== void 0 || height !== void 0) ? { width, height } : null;

    return (
      <div className={ERROR_PANEL_CLASS + (className ? ' ' + className : '')} style={style}>
        <Alert className={ERROR_MESSAGE_CLASS} color="danger">
          {message ? message : 'An error occurred'}
        </Alert>
      </div>
    );
  }
}
